export enum AdminOrderShipmentComponentGroupType {
  Product = 'PRODUCT',
  Box = 'BOX',
  Cosmetic = 'COSMETIC',
}
